import filters from '@/filters'

function parseFraction(v) {
  const pattern = /^([0-9]+\s*)?(([0-9]+)(?:\/)([1-9][0-9]*))?$/
  let x = v.match(pattern)
  var inches = x ? x[0] ? x[0] : 0 : null;
  var num = x ? x[2] ? x[2] : 0 : null;
  var den = x ? x[3] ? x[3] : 0 : null;

  if (x == false) {
    return `Not able to parse ${v}`
  }
  if (den == 0) {
    return filters.Round(parseFloat(inches),3)
  } else {
    return filters.Round(parseFloat(inches)+parseFloat(num)/parseFloat(den),3)
  }
}

export default parseFraction;